<template>
  <div class="bg-login">
    <div class="login-header container title">
      <div>
        <el-image style="width: 150px; height: 61px" src="../../static/Logo_WG.png" fit="scale-down"></el-image>
        <div style="font-size:30px;margin-bottom:5px;color:lightblue;padding-bottom:5px;">游戏联运商户数据管理系统</div>
      </div>
    </div>
    <div class="main">
      <div class="middle-box loginscreen bg-white">
        <div class="login-top"></div>
        <div class="container">
          <div class="login-title text-center">
            <p style="color:block;font-size:20px;">手机验证码校验</p>
          </div>
          <div v-if="hasPhone">
            <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm" @submit.native.prevent>
              <el-form-item>
                <div style="text-align:center;color:#666;font-size:14px;line-height:1.6;">
                  6位验证码已发送到 <span style="font-weight:bold;color:#333;">{{ maskedPhone }}</span>，请在
                  <span style="color:#E6A23C;font-weight:bold;">{{ expireMinutes }}:{{ expireSecondsStr }}</span> 分内输入验证码
                </div>
              </el-form-item>
              <el-form-item prop="code">
                <div style="display:flex;align-items:center;">
                  <el-input v-model="verifyForm.code" placeholder="请输入验证码" maxlength="6" v-focus style="flex:1;"></el-input>
                  <el-button :disabled="countdown > 0" @click="sendCode" type="primary" plain
                    style="margin-left:10px;width:auto;white-space:nowrap;">
                    {{ resendText }}
                  </el-button>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button class="bt-width" type="primary" @click="handleVerify('verifyForm')">验证</el-button>
              </el-form-item>
              <el-form-item style="margin-bottom:0;">
                <div style="display:flex;justify-content:space-between;">
                  <el-button type="text" @click="showChangePhone">手机号已变更？点击修改</el-button>
                  <el-button type="text" @click="handleBack">返回登录</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <div style="text-align:center;padding:20px 10px;">
              <i class="el-icon-warning" style="font-size:48px;color:#E6A23C;"></i>
              <p style="color:#333;font-size:16px;margin-top:15px;">您的账户尚未绑定手机号</p>
              <p style="color:#666;font-size:14px;">请联系管理员进行手机号绑定</p>
              <div style="background:#f5f7fa;border-radius:4px;padding:15px;margin-top:15px;text-align:left;color:#555;font-size:14px;line-height:2;">
                <div><i class="el-icon-user" style="margin-right:8px;"></i>SingleId：SA_ADMIN_001</div>
                <div><i class="el-icon-message" style="margin-right:8px;"></i>邮箱：admin_support@company.com</div>
                <div><i class="el-icon-chat-dot-round" style="margin-right:8px;"></i>QQ：88886666</div>
              </div>
            </div>
            <div style="text-align:center;margin-top:10px;">
              <el-button type="text" @click="handleBack">返回登录</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="更换手机号" :visible.sync="changePhoneDialogVisible" width="450px" center>
      <el-form :model="changePhoneForm" :rules="changePhoneRules" ref="changePhoneForm" label-width="100px">
        <el-form-item label="原手机号">
          <el-input :value="maskedPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="新手机号" prop="newPhone">
          <el-input v-model="changePhoneForm.newPhone" placeholder="请输入新手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="变更原因" prop="reason">
          <el-input type="textarea" v-model="changePhoneForm.reason" placeholder="请输入变更原因" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="changePhoneDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitChangePhone('changePhoneForm')">确认更换</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "phoneVerify",
  data: function() {
    var validatePhone = function(rule, value, callback) {
      if (!value) { callback(new Error('请输入手机号')); }
      else if (!/^1[3-9]\d{9}$/.test(value)) { callback(new Error('请输入正确的手机号')); }
      else { callback(); }
    };
    return {
      mockUserPhone: '13800138000',
      mockCode: '123456',
      verifyForm: { code: '' },
      verifyRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码为6位数字', trigger: 'blur' }
        ]
      },
      codeSent: false,
      countdown: 0,
      countdownTimer: null,
      expireCountdown: 0,
      expireTimer: null,
      changePhoneDialogVisible: false,
      changePhoneForm: { newPhone: '', reason: '' },
      changePhoneRules: {
        newPhone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        reason: [{ required: true, message: '请输入变更原因', trigger: 'blur' }]
      },
      changeRecords: JSON.parse(window.sessionStorage.getItem('phoneChangeRecords') || '[]')
    };
  },
  computed: {
    hasPhone: function() { return !!this.mockUserPhone; },
    maskedPhone: function() {
      if (!this.mockUserPhone) return '';
      return this.mockUserPhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    expireMinutes: function() { return Math.floor(this.expireCountdown / 60); },
    expireSecondsStr: function() {
      var s = this.expireCountdown % 60;
      return s < 10 ? '0' + s : '' + s;
    },
    resendText: function() {
      if (this.countdown > 0) return this.countdown + 's后重发';
      return '重新发送';
    }
  },
  directives: {
    focus: { inserted: function(el) { el.querySelector('input').focus(); } }
  },
  created: function() {
    if (this.hasPhone) { var self = this; this.$nextTick(function() { self.sendCode(); }); }
    var self = this;
    document.onkeydown = function(e) {
      var key = window.event ? window.event.keyCode : e.keyCode;
      if (key === 13 && self.hasPhone) self.handleVerify('verifyForm');
    };
  },
  beforeDestroy: function() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
    if (this.expireTimer) clearInterval(this.expireTimer);
  },
  methods: {
    sendCode: function() {
      if (this.countdown > 0) return;
      this.codeSent = true;
      this.countdown = 60;
      this.expireCountdown = 180;
      var self = this;
      if (this.expireTimer) clearInterval(this.expireTimer);
      this.expireTimer = setInterval(function() {
        self.expireCountdown--;
        if (self.expireCountdown <= 0) {
          clearInterval(self.expireTimer); self.expireTimer = null;
          self.$message.warning('验证码已过期，请重新发送');
        }
      }, 1000);
      this.$message.success('验证码已发送至 ' + this.maskedPhone);
      this.countdownTimer = setInterval(function() {
        self.countdown--;
        if (self.countdown <= 0) { clearInterval(self.countdownTimer); self.countdownTimer = null; }
      }, 1000);
    },
    handleVerify: function(formName) {
      var self = this;
      this.$refs[formName].validate(function(valid) {
        if (!valid) return;
        if (!self.codeSent) { self.$message.warning('请先发送验证码'); return; }
        if (self.expireCountdown <= 0) { self.$message.error('验证码已过期，请重新发送'); return; }
        if (self.verifyForm.code === self.mockCode) {
          self.$message.success('验证通过');
          window.sessionStorage.setItem('phoneVerified', 'true');
          window.sessionStorage.removeItem('pendingPhoneVerify');
          var homePath = window.sessionStorage.getItem('home_path');
          self.$router.push({ path: homePath || '/' });
        } else {
          self.$message.error('验证码错误，请重新输入');
        }
      });
    },
    showChangePhone: function() { this.changePhoneDialogVisible = true; },
    submitChangePhone: function(formName) {
      var self = this;
      this.$refs[formName].validate(function(valid) {
        if (!valid) return;
        var record = {
          username: window.sessionStorage.getItem('username') || '',
          oldPhone: self.mockUserPhone, newPhone: self.changePhoneForm.newPhone,
          reason: self.changePhoneForm.reason, time: new Date().toLocaleString()
        };
        self.changeRecords.push(record);
        window.sessionStorage.setItem('phoneChangeRecords', JSON.stringify(self.changeRecords));
        self.mockUserPhone = self.changePhoneForm.newPhone;
        self.changePhoneDialogVisible = false;
        self.changePhoneForm = { newPhone: '', reason: '' };
        self.codeSent = false; self.verifyForm.code = '';
        if (self.countdownTimer) { clearInterval(self.countdownTimer); self.countdownTimer = null; }
        if (self.expireTimer) { clearInterval(self.expireTimer); self.expireTimer = null; }
        self.countdown = 0; self.expireCountdown = 0;
        self.$message.success('手机号已更换，请重新发送验证码');
      });
    },
    handleBack: function() {
      window.sessionStorage.removeItem('pendingPhoneVerify');
      window.sessionStorage.removeItem('token');
      this.$router.push('/login');
    }
  }
};
</script>
<style scoped>
.bg-login{
  background-color: #324057;
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
.main{
  display: flex;
  justify-content: center;
}
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.title{
  display: flex;
  justify-content: center;
  align-items: end;
}
.bg-white{
  background-color: #ffffff;
}
.middle-box{
  max-width: 400px;
  width: 400px;
}
.login-top{
  background-color: #ffffff;
  height: 6px;
}
.login-title{
  font-weight:bold;
}
.login-header{
  height:265px;
}
.middle-box .el-input {
  display: inline-block;
}
.middle-box .el-button {
  display: inline-block;
  width:100%;
}
.bt-width{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/phone_verify.vue